import debounce from 'lodash/debounce';
import * as React from 'react';

export class DebouncedInputField extends React.Component {
  static defaultProps = {
    value: '',
    onChange: () => {},
    type: 'text'
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      lastDebouncedValue: props.value || '',
      isDebouncing: false,
      lastReceivedValue: props.value
    };

    // Have to create the debounced function here instead of specifying it as
    // a separate field in order for the debounced function to be generated
    // separately for each component instance.
    this._scheduleChange = debounce(() => this._commitChange(), 1000);
  }

  static getDerivedStateFromProps(props, state) {
    // Only process the new props if they've actually changed since we last saw
    // them, so this reacts only to a genuine parent-driven props update and
    // not to every render.
    if (state.lastReceivedValue === props.value) {
      return null;
    }

    if (state.isDebouncing) {
      // While a debounce is in flight the locally-typed value is newer than the
      // parent's, so only record that the props arrived.
      return { lastReceivedValue: props.value };
    }

    return {
      value: props.value,
      lastDebouncedValue: props.value || '',
      lastReceivedValue: props.value
    };
  }

  componentWillUnmount() {
    this._scheduleChange.cancel();
  }

  render(): React.Node {
    return (
      <input
        {...this.props}
        type={this.props.type}
        value={this.state.value}
        onChange={this._handleChange}
        onBlur={this._handleBlur}
      />
    );
  }

  _handleChange = evt => {
    this.setState({
      value: evt.target.value
    });

    this.setState({ isDebouncing: true });
    this._scheduleChange();
  };

  _handleBlur = () => {
    this._commitChange();
  };

  _commitChange = () => {
    if (this.state.lastDebouncedValue !== this.state.value) {
      this.setState({ lastDebouncedValue: this.state.value });
      this.props.onChange(this.state.value);
    }
    this.setState({ isDebouncing: false });
  };
}
